import { Component, OnInit, Input, HostBinding, input } from '@angular/core';
import { SeparatorComponent } from '@exl-ng/mulo-common';
import { TagComponent } from './tag/tag.component';


@Component({
    selector: 'exl-tags',
    templateUrl: './tags.component.html',
    styleUrls: ['./tags.component.scss'],
    host: { 'class': 'exl-tags' },
    imports: [TagComponent, SeparatorComponent]
})
export class TagsComponent implements OnInit {

    // TODO: Skipped for migration because:
    //  This input is used in a control flow expression (e.g. `@if` or `*ngIf`)
    //  and migrating would break narrowing currently.
    @Input() tags;
    readonly url = input(true);
    @HostBinding('class.exl-tags') true;

    constructor() { }

    ngOnInit() {
    }

}
